import Skeleton from "@mui/material/Skeleton";
import {
  StatRow,
  StatsSection,
  StatsTable,
  StatsTableHeader,
  StatsTablesContainer,
} from "./StatsTableStyles";

const TABLE_TITLES = ["Кваліфікація", "Спринт", "Гонка"];
const ROWS_PER_TABLE = 10;

// Label widths are jittered per row so the three columns don't line up into an obviously synthetic
// grid; the pattern is fixed (not random) so re-renders don't reshuffle the bars mid-load.
const LABEL_WIDTHS = [120, 96, 140, 88, 132, 104, 156, 92, 124, 112];

const StatsTablesSkeleton = () => (
  <StatsSection>
    <StatsTablesContainer>
      {TABLE_TITLES.map((title, tableIndex) => (
        <StatsTable key={title}>
          <StatsTableHeader>
            <Skeleton variant="text" width={140} height={25} sx={{ bgcolor: "grey.900" }} />
          </StatsTableHeader>
          {Array.from({ length: ROWS_PER_TABLE }, (_, rowIndex) => (
            <StatRow key={rowIndex}>
              <Skeleton
                variant="text"
                width={LABEL_WIDTHS[(rowIndex + tableIndex * 3) % LABEL_WIDTHS.length]}
                height={20}
                sx={{ bgcolor: "grey.900" }}
              />
              <Skeleton variant="text" width={44} height={20} sx={{ bgcolor: "grey.900" }} />
            </StatRow>
          ))}
        </StatsTable>
      ))}
    </StatsTablesContainer>
  </StatsSection>
);

export default StatsTablesSkeleton;
